import { Lightbulb, SquarePen, LayoutGrid, Settings } from "lucide-react";
import { Link, useLocation } from "react-router";

import { EXPLORE_ENABLED } from "@/config/featureFlags";
import { isResetPasswordAppShell } from "@/lib/authRecovery";
import { cn } from "@/lib/utils";
import { useAuthStore } from "@/store/authStore";

const navItems = [
  ...(EXPLORE_ENABLED
    ? [{ icon: Lightbulb, label: "Explore", path: "/explore" }]
    : []),
  { icon: SquarePen, label: "Create", path: "/create" },
  { icon: LayoutGrid, label: "My Shelf", path: "/my-shelf" },
];

export function DesktopSidebar() {
  const location = useLocation();
  const { user, recoverySessionActive } = useAuthStore();

  // Hide on create/edit and app runtime pages
  const hidePaths = ["/create", "/app/", "/join/"];
  if (
    (!user &&
      !isResetPasswordAppShell(location.pathname, recoverySessionActive)) ||
    hidePaths.some(p => location.pathname.startsWith(p))
  ) {
    return null;
  }

  const isActive = (path: string) =>
    path === "/"
      ? location.pathname === "/"
      : location.pathname.startsWith(path);

  return (
    <aside className="bg-background fixed top-[calc(3.5rem+env(safe-area-inset-top))] bottom-0 left-0 z-40 hidden w-20 flex-col items-center border-r border-zinc-200 py-6 lg:flex">
      <nav className="flex w-full flex-1 flex-col items-center gap-4">
        {navItems.map(item => {
          const active = isActive(item.path);
          return (
            <Link
              key={item.path}
              to={item.path}
              title={item.label}
              className={cn(
                "flex h-12 w-12 cursor-pointer items-center justify-center rounded-xl transition-colors",
                active
                  ? "bg-[#EBECF3] text-foreground"
                  : "text-muted-foreground hover:bg-muted/50 hover:text-foreground",
              )}
            >
              <item.icon
                strokeWidth={active ? 2 : 1.5}
                className={cn("h-6 w-6")}
              />
            </Link>
          );
        })}
      </nav>
      <div className="flex flex-col items-center pb-4">
        <Link
          to="/settings"
          title="Settings"
          className={cn(
            "flex h-12 w-12 cursor-pointer items-center justify-center rounded-xl transition-colors",
            isActive("/settings")
              ? "bg-[#EBECF3] text-foreground"
              : "text-muted-foreground hover:bg-muted/50 hover:text-foreground",
          )}
        >
          <Settings
            strokeWidth={isActive("/settings") ? 2 : 1.5}
            className="h-6 w-6"
          />
        </Link>
      </div>
    </aside>
  );
}
